import React, { useRef, useState } from "react";
import { Button, Input, Checkbox } from "@public/ui-toolkit";
import { useFormik } from "formik";
import * as Yup from "yup";
import AuthLayout from "../AuthLayout";

const LoginForm = ({ onSubmit, loading, history, loginTitle }) => {

  const [showPassword, setShowPassword] = useState(false);

  const togglePasswordVisibility = () => {
    setShowPassword(showPassword ? false : true);
  };

  const emailEl = useRef(null);
  const passwordEl = useRef(null);
  const checkBoxEl = useRef(null);
  const formik = useFormik({
    initialValues: {
      password: "",
      email: "",
      rememberClient: "false",
    },
    validationSchema: Yup.object({
      password: Yup.string()
        .required("Please enter your password.")
        .min(3, "Password is too short - should be 8 chars minimum."),
      // .matches(/[a-zA-Z]/, "Password can only contain Latin letters."),
      email: Yup.string()
        .email("Invalid email address.")
        .required("Please enter your email address."),
    }),
    onSubmit: (values) => {
      JSON.stringify(values, null, 2);
      onSubmit(values);
    },
  });

  return (
    <div className="initial-screen-content">
      <h1 className="content-title">{loginTitle}</h1>
      <form onSubmit={formik.handleSubmit}>
        <div className="row gy-md-4 gy-3">
          <div className="col-12">
            <div className="form-floating">
              <Input
                id="email"
                placeholder="Email"
                label="Email"
                forr="email"
                inputRef={emailEl}
                {...formik.getFieldProps("email")}
              />
              {formik.touched.email && formik.errors.email ? (
                <div className="form-error-message">{formik.errors.email}</div>
              ) : null}
            </div>
          </div>
          <div className="col-12">
            <div id="show_hide_password" className="form-floating">
              <Input
                type={showPassword ? " text" : "password"}
                id="password"
                placeholder="Password"
                label="Password"
                forr="password"
                inputRef={passwordEl}
                eyeVisibility={showPassword ? "fa fa-eye" : "fa fa-eye-slash"}
                onClick={togglePasswordVisibility}
                {...formik.getFieldProps("password")}
              />
              {formik.touched.password && formik.errors.password ? (
                <div className="form-error-message">
                  {formik.errors.password}
                </div>
              ) : null}
              <div className="d-flex justify-content-end align-items-center m-2 ">
                <a
                  href
                  className="d-inline-block text-berylline"
                  onClick={() => history.push("/forget-password")}
                >
                  <u>Forget Password</u>
                </a>
              </div>
            </div>
          </div>
          <div className="col-12">
            <div className="row justify-content-between">
              <div className="col">
                <div className="form-check">
                  <Checkbox
                    checkBoxRef={checkBoxEl}
                    label={"Remember Me"}
                    type={"checkbox"}
                    id={"rememberClient"}
                    {...formik.getFieldProps("rememberClient")}
                  />
                </div>
              </div>
            </div>
          </div>
        </div>
        <Button
          btnName="Login"
          btnType="primary"
          type="submit"
          loading={loading}
        />
        <p className="mt-4 mb-0">
          Don't have an account?{" "}
          <a href="/sign-up" className="d-inline-block text-berylline">
            <u>Signup</u>
          </a>
        </p>
      </form>
    </div>
  );
};

LoginForm.propTypes = {};

export default AuthLayout()(LoginForm);
